<nav class="bg-[#181636] py-3 px-4 lg:p-5 shrink-0 shadow-sm">
    <div class="container lg:max-w-7xl mx-auto text-center">
        <img
            alt="Main Logo"
            class="shrink-0 h-10 mx-auto aspect-[5/2] object-contain"
            [src]="appStore.customStyling().active? appStore.customStyling().logo_url : '/assets/imgs/unipin-logo-white.svg'"
        />

        @if (appStore.customStyling().active && appStore.customStyling().game_name) {
            <div class="font-bold mt-2">
                {{ appStore.customStyling().game_name }}
            </div>
        }
    </div>
</nav>

<main class="p-5 lg:px-8 lg:py-14 grow overflow-y-auto">
    <div class="mb-4 flex gap-2">
        <button class="px-4 py-2 bg-red-500 text-white rounded" (click)="triggerBeError()">Trigger BE Error</button>
        <button class="px-4 py-2 bg-blue-500 text-white rounded" (click)="triggerFeError()">Trigger FE Error</button>
        <button class="px-4 py-2 bg-green-500 text-white rounded" (click)="triggerCombinedError()">Trigger Combined Error</button>
    </div>
    <router-outlet />
</main>
